import React from 'react';
import ResourceLayout from './ResourceLayout';

const EvaluationTemplates = () => {
  const content = (
    <div className="space-y-8">
      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Course Evaluation Survey</h2>
        <div className="space-y-6">
          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Section 1: Overall Experience</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium mb-2">1. How would you rate this course overall?</p>
                <div className="flex flex-wrap gap-4">
                  {['Excellent', 'Very Good', 'Good', 'Fair', 'Poor'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="overall" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">2. Would you recommend this course to a colleague?</p>
                <div className="flex flex-wrap gap-4">
                  {['Definitely', 'Probably', 'Possibly', 'Probably Not', 'Definitely Not'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="recommend" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">3. How relevant was this course to your professional development needs?</p>
                <div className="flex flex-wrap gap-4">
                  {['Extremely Relevant', 'Very Relevant', 'Somewhat Relevant', 'Not Very Relevant', 'Not Relevant'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="relevance" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Section 2: Content Quality</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium mb-2">4. The course content was well-organized and easy to follow.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="organization" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">5. The course materials were helpful and of high quality.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="materials" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">6. The activities and exercises enhanced my learning.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="activities" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Section 3: Instructor Effectiveness</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium mb-2">7. The instructor was knowledgeable about the subject matter.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="knowledge" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">8. The instructor facilitated engaging discussions and activities.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="engagement" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">9. The instructor was responsive to questions and provided helpful feedback.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="responsiveness" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Section 4: Learning Outcomes</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium mb-2">10. I achieved the learning objectives outlined for this course.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="objectives" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">11. I can apply what I learned to my professional practice.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="application" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-medium mb-2">12. This course will positively impact my effectiveness as an educator.</p>
                <div className="flex flex-wrap gap-4">
                  {['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'].map((option) => (
                    <label key={option} className="flex items-center space-x-2">
                      <input type="radio" name="impact" className="text-primary" />
                      <span className="text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Section 5: Open-Ended Feedback</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium mb-2">13. What did you like most about this course?</p>
                <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] bg-background"></div>
              </div>
              <div>
                <p className="font-medium mb-2">14. What could be improved about this course?</p>
                <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] bg-background"></div>
              </div>
              <div>
                <p className="font-medium mb-2">15. What additional topics would you like to see covered?</p>
                <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] bg-background"></div>
              </div>
              <div>
                <p className="font-medium mb-2">16. Any other comments or suggestions?</p>
                <div className="border border-muted-foreground/30 rounded p-3 min-h-[60px] bg-background"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-card p-6 rounded-lg border">
        <h2 className="text-2xl font-bold text-primary mb-4">Instructor Self-Evaluation</h2>
        <div className="space-y-6">
          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Course Preparation & Planning</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Learning objectives were clearly defined and communicated</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Course content was well-organized and logically sequenced</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Materials and resources were prepared in advance</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Activities aligned with learning objectives</span>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Facilitation & Engagement</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Created an inclusive and supportive learning environment</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Encouraged active participation from all participants</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Used varied instructional strategies to accommodate different learning styles</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Maintained energy and enthusiasm throughout the session</span>
              </div>
            </div>
          </div>

          <div className="border border-muted-foreground/20 rounded-lg p-4">
            <h3 className="font-semibold text-lg mb-3">Communication & Feedback</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Provided clear instructions and explanations</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Responded appropriately to questions and concerns</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Gave constructive feedback on participant work</span>
              </div>
              <div className="flex items-start space-x-3">
                <input type="checkbox" className="mt-1 text-primary" />
                <span className="text-sm">Checked for understanding regularly</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ResourceLayout
      title="Evaluation Templates"
      description="Comprehensive evaluation forms for gathering feedback from participants and self-assessment tools for instructors"
      content={content}
    />
  );
};

export default EvaluationTemplates;